import { initializeApp } from 'firebase/app';
import { getFirestore, connectFirestoreEmulator } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: window._ENV_.REACT_APP_FIREBASE_API_KEY,
  authDomain: window._ENV_.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: window._ENV_.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: window._ENV_.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: window._ENV_.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: window._ENV_.REACT_APP_FIREBASE_APP_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore
export const db = getFirestore(app);

// Initialize Auth
export const auth = getAuth(app);

// Connect to emulator in development
if (window._ENV_.REACT_APP_USE_FIREBASE_EMULATOR === 'true' && window._ENV_.NODE_ENV === 'development') {
  connectFirestoreEmulator(db, 'localhost', 8080);
}

export default app;
